import { Link } from "react-router-dom";
import "./ProductListing.css";

import Dash from "../../components/Dash/Dash";

import {
  product1,
  product2,
  product3,
  product4,
  product5,
  product7,
  product4_icon,
  product5_icon,
  product6_icon,
  whiteArrow,
  coloredArrow,
  dryCoolProduct,
  dryCool_home_icon,
  strecthIcon,
  product8,
  cdpthumb,
  cdplogowhite,
  sflexlogowhite,
  sflexthumb,
  dryCoolPdf,
  sFlexPdf,
  cdpDigitalPdf,
  whiteArrow2,
  strechYarnDigitalPdf,
  strechYarnPLP,
} from "../../images";
import { useEffect } from "react";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";

const ProductListing = () => {
  const breadcrumbSchema = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home Page",
        item: "https://www.sanathan.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Products",
        item: "https://www.sanathan.com/products",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Cotton Yarn",
        item: "https://www.sanathan.com/products/cotton-yarn",
      },
      {
        "@type": "ListItem",
        position: 4,
        name: "Polyester Yarn",
        item: "https://www.sanathan.com/products/polyester-yarn",
      },
      {
        "@type": "ListItem",
        position: 5,
        name: "Yarns for Technical Textile",
        item: "https://www.sanathan.com/products/yarn-for-technical-textile",
      },
      {
        "@type": "ListItem",
        position: 6,
        name: "Reviro",
        item: "https://www.sanathan.com/products/reviro",
      },
      {
        "@type": "ListItem",
        position: 7,
        name: "Born Dyed",
        item: "https://www.sanathan.com/products/born-dyed",
      },
      {
        "@type": "ListItem",
        position: 8,
        name: "Dry Cool",
        item: "https://www.sanathan.com/products/dry-cool",
      },
      {
        "@type": "ListItem",
        position: 9,
        name: "Stretch Yarn",
        item: "https://www.sanathan.com/products/stretch-yarn",
      },
      {
        "@type": "ListItem",
        position: 10,
        name: "S-Flex",
        item: "https://www.sanathan.com/products/s-flex",
      },
      {
        "@type": "ListItem",
        position: 11,
        name: "CDP",
        item: "https://www.sanathan.com/products/cationic-dyeable-polyester",
      },
    ],
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* <MetaDecorator /> */}
      <MetaDecorator
        canonicalLink="https://www.sanathan.com/products"
        // metaTitle="Our Products | Yarn Manufacturers in India - Sanathan Textiles"
        metaTitle="Cotton, Polyester & Technical Yarns | Sanathan Textiles"
        // metaDesc="Discover Sanathan's diverse range of high-quality yarn products. As a renowned name in the textile industry in India, we offer value added yarn for various applications."
        metaDesc="Discover over 12,000 types of yarn at Sanathan Textiles, including cotton, polyester, and technical yarns. Explore made-to-order, niche, and value-added yarn solutions tailored for diverse industrial and textile needs."
        schema={breadcrumbSchema}
      />
      <section className="product_listing" data-aos="fade-in">
        <div className="wrapper">
          <div className="breadcrumb_styles">
            <Link to="/" className="breadcrumb_link">
              Home
            </Link>{" "}
            {">"} Our Products
          </div>
          <div className="products">
            <ul>
              <li data-aos="fade-up">
                <h1 className="hollow_title">Our Products</h1>
                <div className="dash_wrapper">
                  <Dash />
                </div>
                <h3>
                  Wide range of 12000+ <br /> Yarn products
                </h3>
                <p>
                  We have 3 yarn verticals namely Cotton Yarns, Polyester Yarns
                  and Yarns for Technical textiles & Industrial end-use. Our
                  wide product offering of more than 12000+ types of Yarn gives
                  the customer a unique opportunity for all his yarn sourcing
                  needs under one roof.
                  <br />
                  <br />
                  Our well designed and integrated manufacturing setup is keenly
                  focused on offering customers made to order (MTO) yarns, niche
                  yarns, coloured yarns and other value-added yarns across all 3
                  main yarn divisions.
                  <br />
                  <br />
                  The success of our relationship lies in the stickiness we
                  create with customers to be their first choice of Yarn
                  supplier.
                </p>
              </li>

              <li data-aos="fade-up" className="product_lists">
                <Link to="/products/cotton-yarn">
                  <figure>
                    <img
                      width={1470}
                      height={1500}
                      src={product1}
                      alt="sanathan img"
                      className="product_img"
                      loading="lazy"
                    />
                  </figure>
                  <div className="products_content">
                    <h3>
                      <img
                        src={product6_icon}
                        className="puro_icon"
                        alt="sanathan img"
                      />
                      Cotton yarns
                    </h3>
                    <p>
                      Our range of Pure Cotton Yarns marketed under our brand ‘
                      <Link to="/products/cotton-yarn" className="new_link">
                        Puro Cotton Yarns
                      </Link>
                      ’ is used to make some of the finest fabrics for apparel,
                      suiting, shirting, bedsheets, home textile and other end
                      uses.
                    </p>
                    <div className="bottom_arrow_container">
                      <Link to="/products/cotton-yarn">
                        view product
                        <img
                          className="arrow"
                          src={whiteArrow}
                          alt="sanathan img"
                        />
                      </Link>
                      {/* <span className="arrow">
                      <img src={whiteArrow} alt="sanathan img"/>
                    </span> */}
                    </div>
                    {/* <br/>
                    <div className="bottom_arrow_container broch_link">
                      <a
                        href={dryCoolPdf}
                        target="_blank"
                        rel="noreferrer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Download Brochure
                        <img
                          className="arrow"
                          src={whiteArrow2}
                          alt="sanathan img"
                        />
                      </a>
                    </div> */}
                  </div>
                </Link>
              </li>

              <li data-aos="fade-up" className="product_lists">
                <Link to="/products/polyester-yarn" className="link_box">
                  <figure>
                    <img src={product2} alt="sanathan img" />
                  </figure>
                  <div className="products_content">
                    <h3>Polyester yarns</h3>
                    {/* <p>
                      Our polyester division is a fully integrated setup where
                      our input is petrochemicals to produce different{" "}
                      <Link to="/products/polyester-yarn" className="new_link">
                        types of polyester yarns
                      </Link>
                      .
                    </p> */}
                    <div className="bottom_arrow_container">
                      <Link to="/products/polyester-yarn">
                        view product
                        <img
                          className="arrow"
                          src={whiteArrow}
                          alt="sanathan img"
                        />
                      </Link>
                      {/* <span className="arrow">
                      <img src={whiteArrow} alt="sanathan img"/>
                    </span> */}
                    </div>
                    {/* <br />
                    <div className="bottom_arrow_container broch_link">
                      <a
                        href={dryCoolPdf}
                        target="_blank"
                        rel="noreferrer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Download Brochure
                        <img
                          className="arrow"
                          src={whiteArrow2}
                          alt="sanathan img"
                        />
                      </a>
                    </div> */}
                  </div>
                </Link>
              </li>

              <li data-aos="fade-up" className="product_lists">
                <Link
                  to="/products/yarn-for-technical-textile"
                  className="link_box"
                >
                  <figure>
                    <img src={product3} alt="sanathan img" />
                  </figure>
                  <div className="products_content">
                    <h3>Yarns for Technical Textile</h3>
                    <p>
                      For our
                      <Link
                        to="/products/yarn-for-technical-textile"
                        className="new_link"
                      >
                        Yarn for Technical Textile & Industrial end-use
                      </Link>{" "}
                      <br />
                      vertical, we plan to set up an inhouse facility at our
                      Punjab Manufacturing Facility to make specialised high
                      intrinsic viscosity raw material required to make yarns
                      for technical textiles and industrial enduse.
                    </p>
                    <div className="bottom_arrow_container">
                      <Link to="/products/yarn-for-technical-textile">
                        view product
                        <img
                          className="arrow"
                          src={whiteArrow}
                          alt="sanathan img"
                        />
                      </Link>
                      {/* <span className="arrow">
                      <img src={whiteArrow} alt="sanathan img"/>
                    </span> */}
                    </div>
                    {/* <br />
                    <div className="bottom_arrow_container broch_link">
                      <a
                        href={dryCoolPdf}
                        target="_blank"
                        rel="noreferrer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Download Brochure
                        <img
                          className="arrow"
                          src={whiteArrow2}
                          alt="sanathan img"
                        />
                      </a>
                    </div> */}
                  </div>
                </Link>
              </li>

              <li data-aos="fade-up" className="product_lists">
                <Link to="/products/reviro" className="link_box">
                  <figure>
                    <img src={product4} alt="sanathan img" />
                  </figure>
                  <div className="products_content">
                    <h3>
                      <img
                        src={product4_icon}
                        className="revir_icon"
                        alt="sanathan img"
                      />
                    </h3>
                    <span className="subhead">
                      Our range of recycled products
                    </span>
                    <p className="diff_size">
                      We manufacture products from recycled materials which are
                      sold under the brand ‘Sanathan Reviro’.
                    </p>
                    <div className="bottom_arrow_container reviro_button">
                      <Link to="/products/reviro">
                        view product
                        <img
                          className="arrow"
                          src={whiteArrow}
                          alt="sanathan img"
                        />
                      </Link>
                      {/* <span className="arrow">
                      <img src={whiteArrow} alt="sanathan img"/>
                    </span> */}
                    </div>
                    {/* <br />
                    <div className="bottom_arrow_container broch_link">
                      <a
                        href={dryCoolPdf}
                        target="_blank"
                        rel="noreferrer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Download Brochure
                        <img
                          className="arrow"
                          src={whiteArrow2}
                          alt="sanathan img"
                        />
                      </a>
                    </div> */}
                  </div>
                </Link>
              </li>

              <li
                data-aos="fade-up"
                className="products_inner_wrapper product_lists"
              >
                <Link to="/products/born-dyed" className="link_box">
                  <figure>
                    <img src={product5} alt="sanathan img" />
                  </figure>
                  <div className="products_content">
                    <h3>
                      Born{" "}
                      <img
                        src={product5_icon}
                        className="borndyed_icon"
                        alt="sanathan img"
                      />{" "}
                      Dyed™
                    </h3>
                    <span className="subhead">Colour Polyester yarns</span>
                    <p className="diff_size">
                      Our range of{" "}
                      <Link to="/products/born-dyed" className="new_link">
                        polyester coloured yarns
                      </Link>{" "}
                      - ‘BornDyed’ are made using the dope dyed technology where
                      colour pigment is added to the yarns at the polymerisation
                      stage.
                    </p>
                    <div className="bottom_arrow_container">
                      <Link to="/products/born-dyed">
                        view product
                        <img
                          className="arrow"
                          src={whiteArrow}
                          alt="sanathan img"
                        />
                      </Link>
                      {/* <span className="arrow">
                      <img src={whiteArrow} alt="sanathan img"/>
                    </span> */}
                    </div>
                    {/* <br />
                    <div className="bottom_arrow_container broch_link">
                      <a
                        href={dryCoolPdf}
                        target="_blank"
                        rel="noreferrer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Download Brochure
                        <img
                          className="arrow"
                          src={whiteArrow2}
                          alt="sanathan img"
                        />
                      </a>
                    </div> */}
                  </div>
                </Link>
              </li>

              {/* <li data-aos="fade-up">
                <Link to="/products/functional-yarn">
                  <figure>
                    <img src={product6} alt="sanathan img"/>
                  </figure>
                  <div className="products_content">
                    <h3>Functional Yarns</h3>
                    <p>
                      These Yarn products are developed after continuous
                      research and development. They are designed with special
                      properties to achieve a specific function.
                    </p>
                    <div className="bottom_arrow_container">
                      <Link to="/products/functional-yarn">
                        view product
                        <img className="arrow" src={whiteArrow} alt="sanathan img"/>
                      </Link>
                    </div>
                  </div>
                </Link>
              </li> */}

              <li data-aos="fade-up" className="product_lists">
                <Link to="products/dry-cool" className="link_box">
                  <figure>
                    <img
                      src={dryCoolProduct}
                      alt="sanathan img"
                      className="drycool_product"
                    />
                  </figure>
                  <div className="products_content">
                    <h3>
                      {/* Dry Cool */}
                      <img
                        src={dryCool_home_icon}
                        className="dry_cool_Product_icon"
                        alt="sanathan img"
                      />{" "}
                    </h3>
                    {/* <p>
                      Fabrics made from our range of DryCool™ yarns are durable,
                      lightweight, and breathable. Used for sportswear,
                      athleisure clothing, innerwear, and many other
                      applications.
                    </p> */}
                    <div className="bottom_arrow_container">
                      <Link to="/products/dry-cool">
                        view product
                        <img
                          className="arrow"
                          src={whiteArrow}
                          alt="sanathan img"
                        />
                      </Link>
                      {/* <span className="arrow">
                      <img src={whiteArrow} alt="sanathan img"/>
                    </span> */}
                    </div>
                    <br />
                    <div className="bottom_arrow_container broch_link">
                      <a
                        href={dryCoolPdf}
                        target="_blank"
                        rel="noreferrer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Download Brochure
                        <img
                          className="arrow"
                          src={whiteArrow2}
                          alt="sanathan img"
                        />
                      </a>
                    </div>
                  </div>
                </Link>
              </li>

              <li
                data-aos="fade-up"
                className="products_inner_wrapper product_lists"
              >
                <Link
                  // to={() => false}
                  to="products/stretch-yarn"
                  className="link_box"
                >
                  <figure>
                    <img src={strechYarnPLP} alt="sanathan img" />
                    {/* <img src={product8} alt="sanathan img" /> */}
                  </figure>
                  <div className="products_content">
                    <h3>
                      <img
                        src={strecthIcon}
                        className="dry_cool_Product_icon strecth_icon"
                        alt="sanathan img"
                      />{" "}
                      {/* about Sanathan Stretch */}
                    </h3>
                    {/* <span className="subhead">Colour Polyester yarns</span>
                    <p className="diff_size">
                      - ‘BornDyed’ are made using the dope dyed technology where
                      colour pigment is added to the yarns at the polymerisation
                      stage.
                    </p> */}
                    <div className="bottom_arrow_container">
                      <Link to="/products/stretch-yarn">
                        view product
                        <img
                          className="arrow"
                          src={whiteArrow}
                          alt="sanathan img"
                        />
                      </Link>
                    </div>
                    <br />
                    <div className="bottom_arrow_container broch_link">
                      <a
                        href={strechYarnDigitalPdf}
                        target="_blank"
                        rel="noreferrer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Download Brochure
                        <img
                          className="arrow"
                          src={whiteArrow2}
                          alt="sanathan img"
                        />
                      </a>
                    </div>
                  </div>
                </Link>
              </li>
              <li data-aos="fade-up" className="product_lists">
                <Link to="products/s-flex" className="link_box">
                  <figure>
                    <img
                      src={sflexthumb}
                      alt="sanathan img"
                      className="drycool_product"
                    />
                  </figure>
                  <div className="products_content">
                    <h3>
                      <img
                        src={sflexlogowhite}
                        className="dry_cool_Product_icon"
                        alt="sanathan img"
                      />
                    </h3>
                    <div className="bottom_arrow_container">
                      <Link to="/products/s-flex">
                        view product
                        <img
                          className="arrow"
                          src={whiteArrow}
                          alt="sanathan img"
                        />
                      </Link>
                    </div>
                    <br />
                    <div className="bottom_arrow_container broch_link">
                      <a
                        href={sFlexPdf}
                        target="_blank"
                        rel="noreferrer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Download Brochure
                        <img
                          className="arrow"
                          src={whiteArrow2}
                          alt="sanathan img"
                        />
                      </a>
                    </div>
                  </div>
                </Link>
              </li>
              <li data-aos="fade-up" className="product_lists">
                <Link
                  to="products/cationic-dyeable-polyester"
                  className="link_box"
                >
                  <figure>
                    <img
                      src={cdpthumb}
                      alt="sanathan img"
                      className="drycool_product cdp_img"
                    />
                  </figure>
                  <div className="products_content">
                    <h3>
                      <img
                        src={cdplogowhite}
                        className="dry_cool_Product_icon"
                        alt="sanathan img"
                      />
                    </h3>
                    <div className="bottom_arrow_container">
                      <Link to="/products/cationic-dyeable-polyester">
                        view product
                        <img
                          className="arrow"
                          src={whiteArrow}
                          alt="sanathan img"
                        />
                      </Link>
                    </div>
                    <br />
                    <div className="bottom_arrow_container broch_link">
                      <a
                        href={cdpDigitalPdf}
                        target="_blank"
                        rel="noreferrer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Download Brochure
                        <img
                          className="arrow"
                          src={whiteArrow2}
                          alt="sanathan img"
                        />
                      </a>
                    </div>
                  </div>
                </Link>
              </li>

              <li data-aos="fade-up" className="product_lists">
                <figure>
                  <img src={product7} alt="sanathan img" />
                </figure>
                <div className="products_content">
                  <h3>Customised Yarns</h3>
                  <span className="subhead">Made to Order Yarns</span>
                  <div className="diff_size_p">
                    We offer a varied range of value added products which
                    constitute a significant proportion of our revenues have
                    higher margins since these are tailor-made to customer
                    requirements and distinctive properties and characteristics.{" "}
                    <br />
                    <a className="no_link" href="mailto:sales@sanathan.com">
                      sales@sanathan.com
                    </a>
                  </div>
                </div>
              </li>

              <li>
                <div className="many_things" data-aos="fade-up">
                  <h3>One Yarn Many Things</h3>
                  <div className="bottom_arrow_container_last">
                    <Link className="knowmore_cta" to="/ouryarn-in-your-life">
                      KNOW MORE
                    </Link>
                    <span className="arrow">
                      <img src={coloredArrow} alt="sanathan img" />
                    </span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductListing;
